module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAABYElEQVQ4jYXTsUuVURgG8N/9/JSGDIcQocHJpX8gsSaNHCwEvUgIQXdouEhTm9QQDqKLtDrYGtQgBoaLuFbSVGANTV0ulBiUQij2NXzn6sfxu/lMh/d53ue8z8s5laxahwuYRQ1X8BmLeC7HIOZwHX/wOugblaxaT7GBYWcxh228QmfENXAtxUybZniC/ZJmYdLZBA/aNLdw8T/cWIKrUTHDCBbOMYb+BMdRcQWbmMfvcwz2U7zDUCjs4THu4xDLeBS4Jr5EBh8rWbV+2WnOXXRjB98wiq/4hBs4iEdIQ9Nt9KAL93BJvpsBPMNL9OJp4DpDvOk0GPVgqSTjQ0yE8yrGC1wNfyvhJXZgK4xZxDHuhFtfFOpvMIYsLQjvyl9dX0HYgfXItClfcgZJgWgE118lUVo4kO/re6uQRIIPuNXG5AhTQXOC2ADe4iZ+RM1VZ+OUGsB7+Rfexk9MYq1M+A9gF01M4d/mCwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/healthIcon/xinlv-2.png
// module id = 8yec
// module chunks = 4